import React, { useRef, useEffect } from 'react';
import './index.scss';

interface ClipMaskProps {
  baseImage: string;
  effectImage: string;
}

const ClipMask: React.FC<ClipMaskProps> = ({ baseImage, effectImage }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const img2Ref = useRef<HTMLImageElement>(null);
  const isUpdatingRef = useRef(false);
  const boxValuesRef = useRef({ x: 0, y: 0, w: 0, h: 0 });

  const updateBoxValues = () => {
    if (!containerRef.current) return;
    const box = containerRef.current;
    const rect = box.getBoundingClientRect();
    boxValuesRef.current = {
      x: rect.left,
      y: rect.top,
      w: rect.width,
      h: rect.height,
    };
  };

  const updateClipPath = (mouseX: number, mouseY: number) => {
    if (!img2Ref.current) return;

    const { x: boxX, y: boxY, w: boxW, h: boxH } = boxValuesRef.current;
    const xPercent = ((mouseX - boxX) / boxW) * 200;
    const yPercent = ((mouseY - boxY) / boxH) * 200;

    img2Ref.current.style.clipPath = `
      polygon(
        0% 0px,
        100% 0%,
        ${xPercent.toFixed(2)}% 0%,
        0% ${yPercent.toFixed(2)}%,
        0% 100%
      )
    `;

    isUpdatingRef.current = false;
  };

  const handleMouseMove = (e: MouseEvent) => {
    updateBoxValues();
    const mouseX = e.clientX;
    const mouseY = e.clientY;

    if (!isUpdatingRef.current) {
      isUpdatingRef.current = true;
      requestAnimationFrame(() => updateClipPath(mouseX, mouseY));
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    updateBoxValues();
    container.addEventListener('mousemove', handleMouseMove);

    const handleResize = () => {
      updateBoxValues();
    };
    window.addEventListener('resize', handleResize);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="clip-mask-container" ref={containerRef}>
      <img
        className="clip-mask-effect"
        ref={img2Ref}
        src={effectImage}
        alt="裁剪效果层"
      />
      <img className="clip-mask-base" src={baseImage} alt="基础层" />
    </div>
  );
};

export default ClipMask;